import styled from 'styled-components';

export const TimeMessage = styled.time`
  font-size: ${props => props.theme.font.size.xsmall};
  /* FIXME: Replace color value by theme color value once new-brand branch could be implemented */
  color: #727272;
  font-weight: ${props => props.theme.font.weight.regular};
`;
